// extracted by mini-css-extract-plugin
module.exports = {"container":"change-password_container__2866m","toggle":"change-password_toggle__VzRxT","actions":"change-password_actions__2mEnh","rules":"change-password_rules__3-ejx"};